import { MODEL_DATA } from './metaModelActions'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    models: {},
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MODEL_DATA:
            return state.set('models', Object.assign({}, state.get('models'), action.models))
        default:
            return state
    }
}
